export default __webpack_public_path__ + "static/media/dialtone.2d0b4e16.mp3";